export const name = '$_proposalHistory';
